export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '6428b542-6453-4d85-a0d5-fd5da1e2b848';
export const MODAL_CLOSE_SEC = 2.5;
